<template>
  <v-flex
    xs12
    class="px-4 full-width button-container"
  >
    <v-btn
      color="secondary"
      class="mt-2 mb-4 app-button full-width"
      @click="buttonFunction"
      :id="btnId ? btnId : ''"
      v-bind="$attrs"
    >
      <slot/>
    </v-btn>
  </v-flex>
</template>

<script>
  export default {
    name: 'AppButton',
    props: {
      buttonFunction: {
        type: Function,
        default: () => {}
      },
      btnId: String,
    },
    inheritAttrs: false,
  }
</script>

<style scoped lang="scss">
  .app-button {
    max-width: 400px;
  }

  .btn {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
</style>
